export default class PlayerAssetsModel {
  public headshot: string = null;
}
